/* eslint-disable max-params */
/* eslint-disable max-lines-per-function */
(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('DeleteDataCtrl', DeleteDataController);

  DeleteDataController.$inject = [
    'DeleteDataService',
    'LoadingService',
    '$scope',
    '$location',
    'Flash',
    'MessagesService',
    '$route'
  ];

  function DeleteDataController(DeleteDataService, LoadingService, $scope,
    $location, Flash, MessagesService,
    $route) {
    const vm = this;

    //////////////////////////////////////////
    // Controller data
    vm.availableTypes = [
      {
        label: 'Aferições de Colheita',
        value: 'colheita_afericao'
      },
      {
        label: 'Aferições de Semeadura',
        value: 'semeadura_afericao'
      },
      {
        label: 'Anotações',
        value: 'anotacao'
      },
      {
        label: 'Boletins de Ocorrências de Máquinas',
        value: 'boletim_ocorrencia'
      },
      {
        label: 'Caminhamentos',
        value: 'caminhamento'
      },
      {
        label: 'Ocorrências e Mapas de Infestação',
        value: 'ocorrencia'
      },
      {
        label: 'Registros de Chuva',
        value: 'climatica'
      },
      {
        label: 'Produtividades',
        value: 'produtividade'
      },
      {
        label: 'Recomendações de Aplicações',
        value: 'recomendacao_aplicacao'
      },
      {
        label: 'Recomendações de Semeadura',
        value: 'recomendacao_semeadura'
      },
      {
        label: 'Stands',
        value: 'stand'
      },
      {
        label: 'Plantio Simplificado',
        value: 'plantio_simplificado'
      },
      {
        label: 'Tarefa',
        value: 'tarefa'
      },
      {
        label: 'Aferição de Aplicação',
        value: 'aplicacao_afericao'
      }
    ];
    vm.selectedTypes = [];
    vm.confirmation = false;
    vm.dateType = 'single';
    vm.singleDate = null;
    vm.multipleDates = [];
    vm.multipleTemp = null;
    vm.interval = {
      start: null,
      end: null
    };
    vm.datepickerOptions = {
      showWeeks: false,
      maxDate: new Date()
    };
    vm.calendarConfig = {
      format: DATE_FORMAT,
      singleOpen: false,
      startOpen: false,
      endOpen: false
    };

    //////////////////////////////////////////
    // Bindable methods
    vm.submit = submit;
    vm.toggleSelectedType = toggleSelectedType;
    vm.openMultiple = openMultiple;
    vm.addDate = addDate;
    vm.removeDate = removeDate;
    vm.isDisabled = isDisabled;
    vm.isIntervalEndBeforeStart = isIntervalEndBeforeStart;

    //////////////////////////////////////////
    // Function declarations

    function submit() {
      return MessagesService.confirm('Você tem certeza que deseja apagar os registros selecionados?')
        .then(() => {
          LoadingService.showLoading();
          if (vm.dateType === 'single') {
            return singleDate();
          } else if (vm.dateType === 'bulk') {
            return bulkDates();
          } else if (vm.dateType === 'interval') {
            return intervalDates();
          }
        })
        .then(() => {
          MessagesService.alert('Registros apagados!');
          $route.reload();
        })
        .catch((error) => {
          if (error) {
            MessagesService.alert('Não foi possível apagar os registros.');
            console.error('Erro:', error);
          }
          // else: cancelou o confirm anterior
        })
        .finally(LoadingService.hideLoading);
    }

    function singleDate() {
      return DeleteDataService.single(vm.singleDate, vm.selectedTypes);
    }

    function bulkDates() {
      return DeleteDataService.bulk(vm.multipleDates, vm.selectedTypes);
    }

    function intervalDates() {
      return DeleteDataService.interval(vm.interval.start, vm.interval.end, vm.selectedTypes);
    }

    function toggleSelectedType(type) {
      const index = vm.selectedTypes.indexOf(type);
      if (index > -1) {
        vm.selectedTypes.splice(index, 1);
      } else {
        vm.selectedTypes.push(type);
      }
    }

    function openMultiple() {
      vm.multipleTemp = null;
      vm.calendarConfig.singleOpen = true;
    }

    function addDate() {
      const date = vm.multipleTemp;
      const exists = vm.multipleDates.find((value) => +value === +date);

      if (!exists) {
        vm.multipleDates.push(date);
      }
      vm.multipleDates = _.sortBy(vm.multipleDates);
    }

    function removeDate(date) {
      const index = vm.multipleDates.indexOf(date);
      vm.multipleDates.splice(index, 1);
      vm.multipleTemp = null;
    }

    function isDisabled(formInvalid) {
      return formInvalid ||
             vm.selectedTypes.length < 1 ||
             (vm.dateType === 'bulk' && vm.multipleDates.length < 1) ||
             (vm.dateType === 'interval' && isIntervalEndBeforeStart());
    }

    function isIntervalEndBeforeStart() {
      return moment(vm.interval.end).isBefore(vm.interval.start);
    }

    //////////////////////////////////////////
    // Controller logic

    LoadingService.showLoading();
    $scope.$root.initialize
      .then(() => {
        LoadingService.hideLoading();
        if (!$scope.$root.isMasterUser()) {
          $location.path('/');
          Flash.create(ACESSO_NAO_PERMITIDO.type, ACESSO_NAO_PERMITIDO.msg);
        }
      })
      .catch($scope.$root.errorRootInitialize);
  }
}());
